'use strict';

var style = require('./style');

module.exports = style({
  prop: 'borderColor',
  key: 'colors'
});


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/styled-system/dist/border-color.js
// module id = 4354
// module chunks = 168707334958949